/* React */
import React, { Component } from 'react';

/* Redux */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withRouter } from 'react-router-dom';
import { actions as ruleActions } from '../../redux/ducks/rule'
import { buildWBoundActions } from '../../redux/ducks'

import Button from '@material-ui/core/Button';
import { SubViewHeaderStep } from '../../lib/components/subHeader';
import { TextInput } from '../../lib/components/textInput';
import { IoteraForm } from '../../lib/components/form';
import { isNone } from 'iotera-base/object';
import { safeDeepGetWithType, safeDeepGet } from 'iotera-base/json';

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

import Result from 'iotera-base/result';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const WKEY = 'RuleUpdate';
const wBoundActions = buildWBoundActions(WKEY);

function schema() {
  return {
    "definitions": {
      "Category": {
        "title": "Category",
        "type": "number",
        "anyOf": [
          {
            type: 'number',
            enum: [
              11
            ],
            title: 'Incoming Device Data'
          }
        ]
      }
    },
    type: "object",
    required: ["name", "category"],
    properties: {
      name: { type: "string", title: "Nama", maxLength: 30 },
      description: { type: "string", title: "Deskripsi", maxLength: 128 },
      category: {
        "$ref": "#/definitions/Category",
        "title": "Category"
      }
    }
  }
};

const uiSchema = {
  name: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="name"
          type="text"
          label="Nama"
          placeholder="Nama"
          textTooltip="Masukkan nama untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  },
  description: {
    "ui:widget": (props) => {
      return (
        <TextInput
          id="description"
          type="text"
          label="Deskripsi"
          placeholder="Deskripsi"
          textTooltip="Masukkan deskripsi untuk rule ini"
          className="custom"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)} />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

function getById(_this, wsKey, id) {
  const _props = _this.props
  const domainIsTenant = dit(_props);
  _props.wInitRequestCall(
    {
      wparam: { ...domainIsTenant, path: '/service/web/rule/get/id/' + id },
      wcallback: {
        started: function (id) {
        },
        finished: function (id, result) {
          const code = safeDeepGet(result, ['code'], Result.UNKNOWN_ERROR);
          if (Result.HTTP.OK === code) {
            const name = safeDeepGet(result, ['body', 'name'], '-');
            const description = safeDeepGet(result, ['body', 'description'], '-');
            _props.setUpdateInfo({
              name,
              description,
              "category": 11
            });
          }
        }
      },
      wreducer: {
        enable: false
      }
    }
  );
}

class RuleUpdateInfo extends Component {
  constructor(props) {
    super(props);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const id = safeDeepGet(_props, ['match', 'params', 'id']);
    if (isNone(id)) {
      return;
    }
    // callback global
    setCallbackGlobal(_props)
    getById(_this, null, id);
  }

  handleNext(data) {
    const _this = this
    const _props = _this.props
    const id = safeDeepGet(_props, ['match', 'params', 'id']);
    _props.setUpdateInfo(data.formData);
    _props.history.push('..' + S + 'trigger' + S + id);
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  handleBack() {
    const _props = this.props
    _props.resetUpdate();
    _props.history.push('../../../../_rule_list_');
  }

  render() {
    const _this = this
    const _props = _this.props
    let info = safeDeepGet(_props, ['info'], {})
    return (
      <div className="view">
        <SubViewHeaderStep title='Ubah Rule' subTitle='Rule Info' steps={['Info', 'Trigger', 'Action']} activeStep={0} />
        <div className="io-container mt-12">
          <IoteraForm
            formData={info}
            schema={schema()}
            uiSchema={uiSchema}
            onSubmit={_this.handleNext}
          >
            <div className="button-right">
              <Button variant="outlined" type="button" size="large"
                style={{ minWidth: '0%' }} onClick={(e) => { _this.handleBack() }} >Kembali</Button>
              <Button variant="contained" size="large" color="primary" type="submit"
                style={{ marginLeft: 10, minWidth: '0%' }}>Lanjut</Button>
            </div>
          </IoteraForm>
        </div>
      </div>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    info: safeDeepGetWithType(state, ['rule', 'update_info'], {})
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(ruleActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RuleUpdateInfo));